import * as React from "react";

export const ChevronUp = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="m18 15-6-6-6 6" />
    </svg>
);

export const ChevronDown = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="m6 9 6 6 6-6" />
    </svg>
);

export const Edit = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M21 20a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zM6.293 13.293l11-11a1 1 0 0 1 1.32-.083l.094.083 3 3a1 1 0 0 1 .083 1.32l-.083.094-11 11a1 1 0 0 1-.576.284L10 18H7a1 1 0 0 1-.993-.883L6 17v-3a1 1 0 0 1 .206-.608zl11-11zM18 4.414l-10 10V16h1.586l10-10z" />
    </svg>
);

export const Print = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M7 10a1 1 0 1 0 1 1 1 1 0 0 0-1-1m12-4h-1V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3h1a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3M8 4h8v2H8Zm8 16H8v-4h8Zm4-5a1 1 0 0 1-1 1h-1v-1a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" />
  </svg>
);